import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'backslash', 'Backslash', [["path",{"d":"M7 5l10 14","key":"svg-0"}]]);